import { Stars, StyledText, TestimonialContainer } from './styles';

interface TestimonialProps {
	text: string;
	isLeft: boolean;
}

const Testimonial = ({ text, isLeft }: TestimonialProps) => {
	return (
		<TestimonialContainer isLeft={isLeft}>
			<StyledText>{text}</StyledText>
			<Stars role="presentation" />
		</TestimonialContainer>
	);
};

export default Testimonial;
